import Col from '@loggi/ui/components/col';
import colors from '@loggi/ui/components/utils/colors';
import View from '@loggi/ui/components/view';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './bicolor-template.styles.scss';

function BicolorTemplate(props) {
  const {
    contentBackground,
    headerClassName,
    contentClassName,
    headerBackground,
    header,
    children
  } = props;

  // We use the same background from the content to the hole template to prevent layout bugs
  const templateBackground = contentBackground;
  const headerClassNames = headerClassName
    ? `template-header ${headerClassName}`
    : 'template-header';
  const contentClassNames = contentClassName
    ? `template-content ${contentClassName}`
    : 'template-content';

  return (
    <View
      flexDirection="column"
      className={styles.bicolorTemplate}
      backgroundColor={templateBackground}
    >
      <Col backgroundColor={headerBackground} className={headerClassNames}>
        {header}
      </Col>
      <Col backgroundColor={templateBackground} className={contentClassNames}>
        {children}
      </Col>
    </View>
  );
}

BicolorTemplate.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  contentBackground: PropTypes.string,
  headerBackground: PropTypes.string,
  contentClassName: PropTypes.string,
  headerClassName: PropTypes.string
};

BicolorTemplate.defaultProps = {
  headerBackground: colors.type.BLUE_700,
  contentBackground: colors.type.WHITE,
  contentClassName: null,
  headerClassName: null
};

BicolorTemplate.displayName = 'BicolorTemplate';

export default BicolorTemplate;
